import ProfessionalPage from "./ProfessionalPage";
export default ProfessionalPage;
